import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { Layer } from 'bernie-view';
import { QueryRoute, updateSearch } from 'bernie-core';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertySummary, PropertySummarySplitted } from '@shared-ui/lodging-property-details';
import { useStoredPdpImageAndPropertyName } from '../../property-details/use-stored-pdp-image-and-property-name';
import { SharedUiHighlightedBenefitsWrapper } from 'src/common/components/infosite/shared-ui/offers/highlighted-benefits-wrapper';
import { SharedUiMap } from 'src/common/components/infosite/shared-ui/details/map-wrapper';
import { SharedUiPropertyReviewsDialog } from '../reviews/shared-ui-property-reviews-dialog';
import { SharedUiUnitsCarouselWrapper } from '../offers/units-carousel-wrapper';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const SummaryWrapper = React.memo(({
  inputs
}) => {
  var _a;
  const history = useHistory();
  const location = useLocation();
  const triggerReviewRef = React.useRef(null);
  const name = (_a = useStoredPdpImageAndPropertyName(inputs.propertyId)) === null || _a === void 0 ? void 0 : _a.name;
  const propertySummaryPlaceHolderData = React.useMemo(() => name ? {
    summary: {
      name
    }
  } : undefined, [name]);
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  const onClickMap = React.useCallback(() => updateSearch({
    history,
    location,
    newParams: {
      pwaDialog: 'map'
    }
  }), [history, location]);
  const onClickReviews = React.useCallback(() => updateSearch({
    history,
    location,
    newParams: {
      pwaDialog: 'reviews'
    }
  }), [history, location]);
  return React.createElement(React.Fragment, null, React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(PropertySummary, {
    onClickReviews: onClickReviews,
    onClickMap: onClickMap,
    inputs: inputs,
    triggerRef: triggerReviewRef,
    placeholderData: propertySummaryPlaceHolderData,
    skipSsr: cSRPropertyDetailsQuery
  }, React.createElement(PropertySummary.CarouselComponent, null, React.createElement(SharedUiUnitsCarouselWrapper, null)), React.createElement(PropertySummary.HighlightedBenefitsComponent, null, React.createElement(SharedUiHighlightedBenefitsWrapper, null))), React.createElement(MapDialogWrapper, null), React.createElement(SharedUiPropertyReviewsDialog, {
    dialogType: "reviews"
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(PropertySummarySplitted, {
    onClickReviews: onClickReviews,
    onClickMap: onClickMap,
    inputs: inputs,
    triggerRef: triggerReviewRef,
    placeholderData: propertySummaryPlaceHolderData,
    skipSsr: cSRPropertyDetailsQuery
  }, React.createElement(PropertySummarySplitted.CarouselComponent, null, React.createElement(SharedUiUnitsCarouselWrapper, null)), React.createElement(PropertySummarySplitted.HighlightedBenefitsComponent, null, React.createElement(SharedUiHighlightedBenefitsWrapper, null))), React.createElement(MapDialogWrapper, null), React.createElement(SharedUiPropertyReviewsDialog, {
    dialogType: "reviews"
  }))));
});
export const MapDialogWrapper = () => {
  const history = useHistory();
  const onCloseDialog = React.useCallback(() => history.goBack(), [history]);
  return React.createElement(QueryRoute, {
    query: {
      pwaDialog: 'map'
    }
  }, React.createElement(Layer, {
    id: "infosite-map",
    onDismiss: onCloseDialog
  }, React.createElement(SharedUiMap, {
    onClose: onCloseDialog
  })));
};
MapDialogWrapper.displayName = 'MapDialogWrapper';
export const SharedUiSummaryWrapper = withSharedUiPropertyDetails(SummaryWrapper);
SharedUiSummaryWrapper.displayName = 'SharedUiSummaryWrapper';